// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2F1oT","row":"ProcedureTreatmentSummary_row__2HoW-"};